import { FC } from 'react';
import { bannerResponseType } from 'types/api/bannerResponseType';
import { bannerParser } from './utils/BannerParcer';
import { Wrap } from './style';

type PropsType = {
  data: bannerResponseType;
};

export const ContentBannerItem: FC<PropsType> = ({ data }) => {
  const { translation } = { ...data };

  const { content = '' } = { ...translation };

  return <Wrap>{bannerParser(content || '')}</Wrap>;
};
